import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useNotificationStateContext from '../../../../../../base/hooks/useNotificationStateContext';

export default () => {
  const { gql, useMutation } = useAppContext();
  const { triggerNotification } = useNotificationStateContext();

  const VirtualAppointmentMutation = gql`
  mutation createVirtualAppointmentLead($input: VirtualAppointmentLeadInput!) {
  createVaLead(input: $input) {
    virtualAppointmentLead {
      email
      firstName
      lastName
      phoneNumber
    }
  }
} 
  `;

  const useVirtualAppointmentMutation = () => useMutation(VirtualAppointmentMutation, {
    onError(e) {
      triggerNotification(e.message, 'error');
    },
  });

  return {
    useVirtualAppointmentMutation,
  };
};